import { templateActions } from "../../actionTypes";

const initialState = {
	template: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case templateActions.LOAD_TEMPLATE: {
			return { ...initialState, fetching: true };
		}

		case templateActions.LOAD_TEMPLATE_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				template: action.payload,
			};
		}

		case templateActions.LOAD_TEMPLATE_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		case templateActions.RESET_LOADED_TEMPLATE: {
			return { ...initialState };
		}

		default:
			return state;
	}
};

export default Reducer;
